// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconMoney = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M4.5 9.63c-.62 0-1.12-.5-1.12-1.12 0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12 0 .62-.5 1.12-1.12 1.12zm15 7.5c-.62 0-1.12-.5-1.12-1.12 0-.62.5-1.12 1.12-1.12.62 0 1.12.5 1.12 1.12 0 .62-.5 1.12-1.12 1.12zm2.25 3.37H2.25C1.01 20.5 0 19.49 0 18.25v-12C0 5.01 1.01 4 2.25 4h19.5C22.99 4 24 5.01 24 6.25v12c0 1.24-1.01 2.25-2.25 2.25zm-19.5-15c-.41 0-.75.34-.75.75v12c0 .41.34.75.75.75h19.5c.41 0 .75-.34.75-.75v-12c0-.41-.34-.75-.75-.75H2.25zM12 16c-2.07 0-3.75-1.68-3.75-3.75 0-2.07 1.68-3.75 3.75-3.75 2.07 0 3.75 1.68 3.75 3.75 0 2.07-1.68 3.75-3.75 3.75zm0-6c-1.24 0-2.25 1.01-2.25 2.25S10.76 14.5 12 14.5s2.25-1.01 2.25-2.25S13.24 10 12 10z"
      fill="currentColor"
    />
  );
export default SvgIconMoney;
